<template>
    <section id="page-lesgeven" class="page page-lesgeven">
        <div class="page__content">
            <div class="page__icon-wrapper"><i class="fa fa-graduation-cap" aria-hidden="true"></i></div>
            <h1>In welk vak zou je willen lesgeven?</h1>

            <div class="container list-select">
                <div class="row">
                    <div class="col-12-sm">
                        <p class="form__label">Ik wil lesgeven in</p>
                        <typeahead
                                key="is-not-docent-interesse-vak"
                                v-on:select="selectVak"
                                :items="vakken" property="vak">
                        </typeahead>
                    </div>
                </div>

                <div class="row" v-if="currentVak">
                    <div class="col-12-sm">
                        <div class="result-box"><p>{{commentSelected}}</p>
                            <div v-if="currentVak">
                                <page-next-button v-on:click="nextHandler"></page-next-button>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
            <br/><br/><br/><br/><br/><br/>
        </div>
    </section>
</template>
<style lang="stylus">

</style>
<script>
    import typeahead from "../../components/typeahead/typeahead.vue";

    import page from './page';

    export default {
        mixins: [page],
        props: {
            vakken: {
                type: Array,
                default: []
            }
        },
        data() {
            return {
                currentVak: null
            }
        },
        computed: {
            commentSelected() {
                let comment;
                const vak = this.currentVak;
                const vakNaam = vak.vak;
                if (vak.tekort) {
                    comment =  `Je hebt een passie voor ${vakNaam}. Mooi! Helemaal omdat dit een tekortvak is, wat betekent dat er op dit moment een tekort aan docenten is. Je bent dus hartstikke hard nodig in het onderwijs en dit vergroot de kans dat je snel een baan vindt.`;
                } else {
                    comment = `Je hebt een passie voor ${vakNaam}. Mooi! Voor bijna alle vakken worden de komende jaren tekorten verwacht. Goede mensen zijn dus altijd nodig in het onderwijs!`;
                }
                return comment;
            }
        },
        methods: {
            selectVak(vak) {
                this.currentVak = vak;
                this.$emit('profileupdate', { key: 'vak2', value: vak });
            }
        },
        components: {
            typeahead
        }
    }
</script>



// WEBPACK FOOTER //
// page-lesgeven.vue?788b85de